module.exports = __webpack_public_path__ + "static/media/WaywardCreaturesJacket.0b42d6d8.jpg";